// Libs
import React, { useState } from "react";
import {
  Button,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  PhotoIcon,
  FolderOpenIcon,
  LinkIcon,
} from "@heroicons/react/24/outline";

// Local
import EmailImagesManager from "./EmailImagesManager";

interface ImageSelectorProps {
  onImageInsert: (imageUrl: string) => void;
  size?: "small" | "medium" | "large";
  variant?: "text" | "outlined" | "contained";
  children?: React.ReactNode;
}

export const ImageSelector: React.FC<ImageSelectorProps> = ({
  onImageInsert,
  size = "medium",
  variant = "outlined",
  children,
}) => {
  const [imagesManagerOpen, setImagesManagerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleManageImages = () => {
    setImagesManagerOpen(true);
    handleClose();
  };

  const handleImageSelect = (imageUrl: string) => {
    onImageInsert(imageUrl);
    setImagesManagerOpen(false);
  };

  const insertImageFromUrl = () => {
    const url = prompt("Enter image URL:");
    if (url && url.trim()) {
      onImageInsert(url.trim());
    }
    handleClose();
  };

  return (
    <>
      <Tooltip title="Insert Image">
        <Button
          size={size}
          variant={variant}
          startIcon={<PhotoIcon className="h-4 w-4" />}
          onClick={handleClick}
        >
          {children || "Insert Image"}
        </Button>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleManageImages}>
          <ListItemIcon>
            <FolderOpenIcon className="h-5 w-5" />
          </ListItemIcon>
          <ListItemText primary="Choose from uploaded images" />
        </MenuItem>

        <MenuItem onClick={insertImageFromUrl}>
          <ListItemIcon>
            <LinkIcon className="h-5 w-5" />
          </ListItemIcon>
          <ListItemText primary="Insert from URL" />
        </MenuItem>
      </Menu>

      <EmailImagesManager
        open={imagesManagerOpen}
        onClose={() => setImagesManagerOpen(false)}
        onImageSelect={handleImageSelect}
      />
    </>
  );
};

export default ImageSelector;
